export default function createLoopWorker() {
  return new Worker(new URL('./worker.js', import.meta.url));
}
